import { Dialog, TextareaField, TextInputField } from 'evergreen-ui';
import { formatTime } from '../utils/timeUtils';

const ViewEntryDialog = ({ isShown, onClose, entry }) => {
  if (!entry) return null;

  const testo = entry.type === 'entry'
    ? (entry.data && entry.data.testo ? entry.data.testo : '')
    : (entry.data && entry.data.azione ? entry.data.azione : (entry.testo || ''));

  const guestLabel = entry.data && (entry.data.guest_nome || entry.data.guest_name)
    ? `${entry.data.guest_nome || entry.data.guest_name} ${entry.data.guest_cognome || ''}`.trim()
    : '';

  const start = entry.start ? new Date(entry.start) : (entry.start_time ? new Date(entry.start_time) : (entry.data && entry.data.start_time ? new Date(entry.data.start_time) : null));
  const end = entry.end ? new Date(entry.end) : (entry.end_time ? new Date(entry.end_time) : (entry.data && entry.data.end_time ? new Date(entry.data.end_time) : null));

  const author = (() => {
    if (entry.type === 'entry') {
      if (entry.data && (entry.data.nome || entry.data.cognome)) return `${entry.data.nome || ''} ${entry.data.cognome || ''}`.trim();
    }
    if (entry.parent && (entry.parent.nome || entry.parent.cognome)) return `${entry.parent.nome || ''} ${entry.parent.cognome || ''}`.trim();
    if (entry.nome || entry.cognome) return `${entry.nome || ''} ${entry.cognome || ''}`.trim();
    return '';
  })();

  const kind = (() => {
    if (entry.type === 'entry') return 'appointment';
    if (entry.type === 'note') return 'note';
    if (entry.entry_type === 'appuntamento') return 'appointment';
    if (entry.entry_type === 'descrizione') return 'description';
    if (entry.data && entry.data.azione) return 'note';
    if (entry.testo) return 'description';
    return 'note';
  })();

  return (
    <Dialog
      isShown={isShown}
      title={kind === 'appointment' ? 'Dettaglio appuntamento' : (kind === 'note' ? 'Dettaglio nota' : 'Dettaglio descrizione giornata')}
      onCloseComplete={onClose}
      hasFooter={false}
    >
      <TextInputField label="Autore" value={author} readOnly />
      {guestLabel && <TextInputField label="Ospite coinvolto" value={guestLabel} readOnly />}
      <div style={{ display: 'flex', gap: 8 }}>
        {start && (
          <div style={{ flex: 1 }}>
            <TextInputField label="Ora di inizio" value={formatTime(start)} readOnly />
          </div>
        )}
        {end && (
          <div style={{ flex: 1 }}>
            <TextInputField label="Ora di fine" value={formatTime(end)} readOnly />
          </div>
        )}
      </div>
  <TextareaField label={entry.type === 'entry' ? 'Descrizione appuntamento' : 'Testo'} value={testo} inputHeight={160} flexibleHeight readOnly />
    </Dialog>
  );
};

export default ViewEntryDialog;
